interface IInlineLoaderProps {
  size?: "sm" | "md" | "lg";
  className?: string;
}

/**
 * InlineLoader component - displays a loading spinner for inline use
 * Used in cards, sections, and other non-full-screen contexts
 */
export const InlineLoader = (props: IInlineLoaderProps) => {
  const { size = "md", className = "" } = props;

  const sizeClasses = {
    sm: "w-4 h-4 border-2",
    md: "w-8 h-8 border-4",
    lg: "w-12 h-12 border-4",
  };

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <div
        className={`${sizeClasses[size]} border-t-orange-500 border-r-transparent border-b-orange-500 border-l-transparent rounded-full animate-spin`}
      />
    </div>
  );
};

export default InlineLoader;


